export default (urlParameters) => {
  return {
    wind_graph: {
      show_data_fields_menu: true,
      show_nearby_spots: true,
      show_virtual: false,
      default_graph: 'detailed'
    },
    station_info: {
      show_full_metadata: true
    },
    archive_data: {
      allow_data_download: true
    }
  }
}